import React, {useState} from 'react';
import {Footer, HeaderNavi, SupportLeftMenu, Pagination} from '@components';
import { useQuery } from '@tanstack/react-query';
import { get } from '@utils/axios_api';
import {  Link } from 'react-router-dom';

const fetchReferenceList = async (pageIndex, itemsPerPage) => {
    const response = await get('/referenceList', {
      params: {
        pageIndex,
        recordCountPerPage: itemsPerPage,
      },
    });
    return response;
  };
const ReferenceList = () => {
    const [pageIndex, setPageIndex] = useState(1);
    const itemsPerPage = 10; 

    const { data, isLoading, isError } = useQuery({
        queryKey: ['referenceList', pageIndex],
        queryFn: () => fetchReferenceList(pageIndex, itemsPerPage),
        keepPreviousData: true,
    });

    const handlePageChange = (pageNumber) => {
        setPageIndex(pageNumber);
    };

    if (isLoading) {
        return <div>로딩 중...</div>;
    }
    
    if (isError) {
        return <div>오류가 발생했습니다</div>;
    }


  return (
    <main id="main" className="mainpage">
            <>
            <div>
                <div className="section main-contact">
                    <HeaderNavi  selectedCategory  />
                    <div className="sub-container">
                        <div className="sub-layout">
                            <SupportLeftMenu />
                            <div className="sub-contact">
                                <h3 className="border-bt" style={{ marginBottom: '0' }}>자료실</h3>
                                <div className="lineTop_tb02">
                                    <table  className="lineTop_tb3">
                                    <colgroup>
                                    <col style={{ width: '50px' }} />
                                    <col style={{ width: '300px' }}/>
                                    <col style={{ width: '100px' }} />
                                    <col style={{ width: '100px' }}/>
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>번호</th>
                                            <th>제목</th>
                                            <th>등록일</th>
                                            <th>파일</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {data?.resultList && data.resultList.length > 0 ? (
                                        data.resultList.map((item, index) => (
                                        <tr key={item.referenceId}>
                                        <td>{(pageIndex - 1) * itemsPerPage + index + 1}</td>
                                        <td style={{textAlign:"left"}}>
                                        {/* <td style={{textAlign:"left"}}> */}
                                            <Link to={`/support/reference/detail?referenceId=${item.referenceId}`}>
                                            {item.title}
                                            </Link>
                                        </td>
                                        <td>{item.regDtm}</td>
                                        <td className="text-cent">{item.atchFileId ? <img src="/img/clip.png" alt="첨부파일"/> : '-'}</td>
                                        </tr>
                                    ))
                                    ) : (
                                    <tr>
                                        <td colSpan="4">자료실 글이 존재 하지 않습니다.</td>
                                    </tr>
                                    )}
                                    </tbody>
                                    </table>
                                    {data?.paginationInfo && data.paginationInfo.totalRecordCount > 0 && (
                                        <Pagination
                                            totalPages={Math.ceil(
                                                data.paginationInfo.totalRecordCount / data.paginationInfo.recordCountPerPage
                                            )}
                                            currentPage={pageIndex}
                                            onPageChange={handlePageChange}
                                            pageRangeDisplayed={5} // 필요에 따라 조정
                                        />
                                    )}
                                </div>
                                        
                                
                            </div>	
                        </div>	
                    </div>
                    <Footer />
                </div>
            </div>
        </>
   </main>


  );
};


export default ReferenceList;
